import styled from '@emotion/styled';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContentBanner, Button, Icon, pxToRem } from '@modernhealth/vital-components';

import { colors } from '@modernhealth/vital-foundation';

import { navigationService } from 'src/config/rootService';
import { ScheduledContentFragment } from 'src/modules/dashboard/documents/getHomeScreen.generated';
import { calculateDailyPauseStreakCTA } from '../util/calculateDailyPauseStreakCTA';

export interface DailyPauseCardProps {
    scheduledContent: ScheduledContentFragment;
    dayStreakCount: number;
    weekStreakCount: number;
    showStreakInfo?: boolean;
}

export const DailyPauseCard: React.FC<DailyPauseCardProps> = ({
    scheduledContent,
    dayStreakCount,
    weekStreakCount,
    showStreakInfo,
}) => {
    const { t } = useTranslation();
    const { bannerTitle, bannerContent, bannerImage, uuid, accentColor, isCompleted } =
        scheduledContent;

    const ctaButtonTitle = isCompleted
        ? t('dailyPause:content_banner.completed_button_text')
        : t('dailyPause:content_banner.button_text');

    const renderStreakInfo = () => (
        <StreakCta variant="outline" onClick={() => navigationService.navigate('/pause/stats')}>
            🔥 {calculateDailyPauseStreakCTA(dayStreakCount, weekStreakCount, t)}{' '}
            <Icon name="chevron-right" />
        </StreakCta>
    );

    return (
        <ContentBanner
            title={bannerTitle}
            description={bannerContent}
            image={bannerImage ?? undefined}
            buttonTitle={ctaButtonTitle}
            onClick={() => navigationService.navigate('/pause', { uuid })}
            backgroundColor={accentColor ? `#${accentColor}` : colors.white}
            buttonProps={{
                startIcon: isCompleted ? 'checkmark' : undefined,
                variant: isCompleted ? 'empty' : 'secondary',
            }}
            footer={showStreakInfo ? renderStreakInfo() : null}
        />
    );
};

const StreakCta = styled(Button)({
    border: 'none',
    color: colors.white,
    paddingLeft: 0,
    marginTop: pxToRem(24),
});
